import React, { useState } from 'react';
import { supabase } from '../../../lib/supabaseClient';
import { useTranslation } from 'react-i18next';

export function ResetPasswordForm({ setView, setError, setMessage, setLoading }) {
  const [email,setEmail] = useState('');
  const { t } = useTranslation();

  const onSubmit = async (e)=>{
    e.preventDefault(); setError(''); setMessage(''); setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: (process.env.REACT_APP_SITE_URL || window.location.origin) + '/user' });
      if(error) throw error;
      setMessage(t('auth.reset.sent_conditional','If the account exists, we sent an email to reset it.'));
    } catch(err){ setError(err.message || t('auth.errors.generic','Something went wrong')); }
    finally { setLoading(false); }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label className="block text-sm text-gray-300 mb-1">{t('auth.email','Email')}</label>
  <input autoFocus type="email" value={email} onChange={e=>setEmail(e.target.value)} required className="input-primary w-full" />
      </div>
      <div className="flex gap-3 justify-end pt-2">
        <button type="button" onClick={()=>setView('login')} className="btn-secondary">{t('common.cancel','Cancel')}</button>
        <button type="submit" className="btn-primary">{t('common.send','Send')}</button>
      </div>
    </form>
  );
}
